<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  rows: {
    type: Number,
    default: 6,
  },
  data: {
    type: Array,
    default: () => [],
  },
});

const data = computed(() =>
  props.data.length ? props.data : Array.from({ length: props.rows })
);
</script>
<template>
  <div class="w-full" v-bind="$attrs">
    <ul
      role="list"
      class="lms-card-grid"
    >
      <li
        v-for="(item, index) in data"
        :key="index"
        class="col-span-1 flex flex-col bg-white rounded-xl border border-untitled-gray-200 overflow-hidden"
      >
        <div class="w-full aspect-video bg-untitled-gray-100 animate-pulse" />
        <div class="flex flex-col gap-3 p-4">
          <div class="h-4 w-3/4 bg-untitled-gray-100 rounded animate-pulse" />
          <div class="flex gap-4">
            <div class="h-3 w-16 bg-untitled-gray-100 rounded animate-pulse" />
            <div class="h-3 w-20 bg-untitled-gray-100 rounded animate-pulse" />
          </div>
          <div class="h-8 w-full bg-untitled-gray-100 rounded-md animate-pulse pt-1" />
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped></style>
